export default {
    StockRules: {
        Header: {
            title: 'Inventory Rules',
            method: 'Decimal Calculation Method',
            down: 'Rounding Down will Round off all Decimals, e.g. 10.896 will be Rounded to 10',
            up: 'Rounding Up will Round off Decimals regardless of the value, and the Integer will be Added by 1, e.g. 12.321 will be Rounded to 13',
            shortage: 'Prioritize Stock Replenishment for Out of Stock Orders',
            channel: 'Set Channel Stock Replenishment Priority',
            rule: 'Out of Stock Order Priority Allocation Rule',
            delivery: 'Sort by Expected Delivery Time, from Closest to Farthest',
            quantity: 'Sort by Out of Stock Quantity',
            quan: 'Sort from Least to Most',
            tity: 'Sort from Most to Least',
            priority: 'Set Priority',
            methods: 'Channel',
            priorit: 'Priority',
        },
        Main: {
            title: 'Inventory Synchronization Rules',
            Channel: 'Channel Synchronization Priority',
            Virtual: 'Virtual warehouse synchronization priority rule',
            Drag: 'Drag and Drop to Reorder, the Higher the Item, the Higher the Priority',
            rule: 'Synchronization Rule for Same Type Virtual Warehouse',
            less: 'Sort by Available Stock from Least to Most',
            creation: 'Sort by Creation Time',
            near: 'From near to far',
            far: 'From far to near',
            warehouse: 'Sort by  warehouse location',
            high: 'Sort from High to Low',
            low: 'Sort from Low to High',
        },
        Bottom: {
            title: 'Inventory Deduction Priority Rule',
            Inventory: 'Inventory Type Deduction Sequence Priority',
            Drag: 'Drag and Drop to Reorder, the Higher the Item, the Higher the Priority',
            rules: 'Synchronization Rule for Same Type Virtual Warehouse',
            creation: 'Sort by Creation Time',
            near: 'From near to far',
            far: 'From far to near',
        },
        Footer: {
            title: 'Inventory Overselling Limitation',
            current: 'The current page data has not been saved, do you want to reset it directly?',
            Canceled: 'Canceled',
            total: 'The Total Proportion of All Channel Warehouses that a Proportional Virtual Warehouse Can Connect to Should Not Exceed',
            The: 'The Total Proportion of All Proportional Virtual Warehouses that a Physical Warehouse Can Connect to is 100%',
        }
    },
};
